import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbsModule } from '@fantaz/shared/layout/breadcrumbs';
import { NavbarModule } from '@fantaz/shared/layout/navbar';
import { ColorSchemeService } from '@fantaz/shared/services/color-scheme';
import { SharedUiColorSchemeSwitcherModule } from '@fantaz/shared/ui/color-scheme-switcher';

@Component({
  selector: 'fz-main-layout',
  standalone: true,
  template: `<ng-content></ng-content>`,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'fz-main-layout',
  },
  styles: [
    `
      .fz-main-layout {
        display: block;
      }

      .fz-main-layout:has(.mat-toolbar.permanent) {
        padding-top: var(--mat-toolbar-standard-height);
      }
    `,
  ],
})
export class MainLayoutComponent {}

@Component({
  selector: 'fz-main-view',
  standalone: true,
  templateUrl: './main-view.component.html',
  styleUrls: ['./main-view.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    NavbarModule,
    BreadcrumbsModule,
    SharedUiColorSchemeSwitcherModule,
    MainLayoutComponent,
  ],
})
export class MainViewComponent {
  constructor(private readonly colorSchemeService: ColorSchemeService) {
    this.colorSchemeService.init();
  }

  get colorScheme() {
    return this.colorSchemeService.get();
  }
}

@Component({
  selector: 'fz-static-view',
  template: `<ng-content></ng-content>`,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaticViewComponent {}
